import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getOrderDetailsById } from "api/order";
import OrderReceiptDocument from "Components/ViewOrder/OrderReceipt/OrderReceiptDocument";
import { AppContext } from "Context/AppContext";
import { MODULES } from "Helpers/Constants";
import { getAccessByModuleName } from "Routes/Routes";
import styles from "./index.module.scss";

const OrderReceipt = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { modules, setIsLoading, showToastMessage } = useContext(AppContext);
  const [order, setOrder] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const access = getAccessByModuleName(modules, MODULES.VIEW_ORDER);

    if (!access) return;

    if (!access.permissions.read_access) {
      showToastMessage(
        undefined,
        "You are not authorized to access this order.",
        "error",
        false
      );
      window.location.href = "/admin/orders/list";
      return;
    }

    let isActive = true;

    const loadOrder = async () => {
      if (!id) return;

      setIsLoading(true);
      setError("");

      try {
        const response = await getOrderDetailsById(id);

        if (isActive && response?.status === 200) {
          setOrder(response.data.data);
          document.title = `${response.data.data.order_number} Receipt | French Florist`;
        } else if (isActive) {
          setError(response?.data?.message || "Unable to load this order.");
        }
      } catch {
        if (isActive) {
          setError("Unable to load this order.");
        }
      } finally {
        if (isActive) setIsLoading(false);
      }
    };

    loadOrder();

    return () => {
      isActive = false;
    };
  }, [id, modules]);

  const returnToOrder = () => {
    window.location.href = `/admin/orders/view/${id}`;
  };

  return (
    <main className={styles.receiptPage}>
      <div className={styles.actionBar}>
        <div>
          <span className={styles.previewLabel}>Print preview</span>
          <strong>{order ? `Order #${order.order_number}` : "Order receipt"}</strong>
        </div>
        <div className={styles.actionButtons}>
          <button
            className={styles.secondaryButton}
            type="button"
            onClick={returnToOrder}
          >
            Back to order
          </button>
          <button
            className={styles.printButton}
            type="button"
            onClick={() => window.print()}
            disabled={!order}
          >
            Print / Save as PDF
          </button>
        </div>
      </div>

      {error && (
        <section className={styles.errorCard}>
          <h1>Receipt unavailable</h1>
          <p>{error}</p>
          <button type="button" onClick={() => navigate("/admin/orders/list")}>
            Return to orders
          </button>
        </section>
      )}

      {order && <OrderReceiptDocument order={order} />}
    </main>
  );
};

export default OrderReceipt;
